import * as React from "react";
import type { SVGProps } from "react";
const SvgMinusExtraSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="currentColor" d="M16 13H8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2" />
  </svg>
);
export default SvgMinusExtraSmall;
